import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";

let teamMemberCancelTokenSource: any;

export const AddTeamMemberAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addTeamMemeber", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .post(`/users`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose(result?.data);
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addTeamMemeber", undefined);
        } else elseHandler(dispatch, "addTeamMemeber", result);
        dispatchLoading(dispatch, "addTeamMemeber", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addTeamMemeber")(e);
      });
  };

const inFlightTeamMemberRequests = new Map<string, Promise<any>>();
const lastTeamMemberRequestTime = new Map<string, number>();

export const GetTeamMemberListAPI =
  (
    {
      page,
      limit,
      search,
      is_active,
      sortBy,
      sortOrder,
      role,
      start_date,
      end_date,
      created_by,
      department,
      roleKey,
      isEmployee,
      isApprover,
      employee_profile_status,
      userId,
      search_name_only,
      isSilent = false,
      force = false,
    }: any,
    setHasMore?: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    const reqKey = JSON.stringify({ page, limit, search, is_active, role, isEmployee, employee_profile_status, userId, search_name_only });

    if (inFlightTeamMemberRequests.has(reqKey)) {
      return inFlightTeamMemberRequests.get(reqKey);
    }
    const lastTime = lastTeamMemberRequestTime.get(reqKey) || 0;
    if (!force && Date.now() - lastTime < 1500) {
      return;
    }

    if (!isSilent) {
      dispatchLoading(dispatch, "getTeamMember", true);
    }
    if (teamMemberCancelTokenSource) {
      teamMemberCancelTokenSource.cancel();
    }
    teamMemberCancelTokenSource = axios.CancelToken.source();
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (sortBy) params["sortBy"] = sortBy;
    if (department) params["department"] = department;
    if (roleKey) params["roleKey"] = roleKey;

    if (sortOrder) params["sortOrder"] = sortOrder;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (created_by) params["created_by"] = created_by;
    if (role) params["role"] = role;
    if (is_active || is_active === 0) params["is_active"] = is_active;
    if (isEmployee) params["isEmployee"] = isEmployee;
    if (isApprover !== undefined) params["isApprover"] = isApprover;
    if (employee_profile_status) params["employee_profile_status"] = employee_profile_status;
    if (userId) params["userId"] = userId;
    if (search_name_only !== undefined) params["search_name_only"] = search_name_only;

    const requestPromise = axiosInstance
      .get(`/users`, {
        params: { ...params },
        cancelToken: teamMemberCancelTokenSource.token,
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = result?.data?.data?.map((user: any) => ({
            ...user,
            email: decryptByText(user?.email),
            name: `${CapitalizeFirstWord(
              decryptByText(user?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(user?.last_name))}`,
            first_name: CapitalizeFirstWord(decryptByText(user?.first_name)),
            last_name: CapitalizeFirstWord(decryptByText(user?.last_name)),
            created_by: user?.created_by
              ? {
                  ...user?.created_by,
                  email: decryptByText(user?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(user?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(user?.created_by?.last_name),
                  ),
                }
              : user?.created_by,
            updated_by: user?.updated_by
              ? {
                  ...user?.updated_by,
                  email: decryptByText(user?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(user?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(user?.updated_by?.last_name),
                  ),
                }
              : user?.updated_by,
          }));
          dispatch({
            type: "GET_TEAM_MEMBER_LIST",
            payload: {
              page: page,
              data: newData,
              count: result?.data?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          if (!isSilent) {
            elseHandler(dispatch, "getTeamMember", result);
          }
          // navigate("/auth/login");
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        if (!isSilent) {
          catchHandler(dispatch, "getTeamMember")(err);
        }
        // navigate("/auth/login");
      })
      .finally(() => {
        inFlightTeamMemberRequests.delete(reqKey);
        lastTeamMemberRequestTime.set(reqKey, Date.now());
        if (!isSilent) {
          dispatchLoading(dispatch, "getTeamMember", false);
        }
      });

    inFlightTeamMemberRequests.set(reqKey, requestPromise);
    return requestPromise;
  };

export const GetTemMemberFilterAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getTeamMemberFilterData", true);

    axiosInstance
      .get(`/users/filter-data`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = result?.data?.created_by?.map((user: any) => ({
            ...user,
            first_name: CapitalizeFirstWord(decryptByText(user?.first_name)),
            last_name: CapitalizeFirstWord(decryptByText(user?.last_name)),
            name: `${CapitalizeFirstWord(
              decryptByText(user?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(user?.last_name))}`,
          }));
          dispatch({
            type: "GET_TEAM_MEMBER_FILTER_DATA",
            payload: newData,
          });
        } else {
          elseHandler(dispatch, "getTeamMemberFilterData", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getTeamMemberFilterData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getTeamMemberFilterData")(err);
        // navigate("/auth/login");
      });
  };

export const GetTeamMemberDetailsAPI =
  ({ page, limit, id, search, is_active, sortBy, sortOrder }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getTeamMemberDetails", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (id) params["id"] = id;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/users`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = result?.data?.data?.map((user: any) => ({
            ...user,
            email: decryptByText(user?.email),
            first_name: CapitalizeFirstWord(decryptByText(user?.first_name)),
            last_name: CapitalizeFirstWord(decryptByText(user?.last_name)),
            name: `${CapitalizeFirstWord(
              decryptByText(user?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(user?.last_name))}`,
            created_by: user?.created_by
              ? {
                  ...user?.created_by,
                  email: decryptByText(user?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(user?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(user?.created_by?.last_name),
                  ),
                }
              : user?.created_by,
            updated_by: user?.updated_by
              ? {
                  ...user?.updated_by,
                  email: decryptByText(user?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(user?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(user?.updated_by?.last_name),
                  ),
                }
              : user?.updated_by,
          }));
          dispatch({
            type: "GET_TEAM_MEMBER_DETAILS",
            payload: newData[0],
          });
        } else {
          elseHandler(dispatch, "getTeamMemberDetails", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getTeamMemberDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getTeamMemberDetails")(err);
        // navigate("/auth/login");
      });
  };

export const UpdateTeamMemberDataAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateTeamMember", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/users`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            email: decryptByText(result?.data?.email),
            first_name: CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            ),
            last_name: CapitalizeFirstWord(
              decryptByText(result?.data?.last_name),
            ),
            name: `${CapitalizeFirstWord(
              decryptByText(result?.data?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(result?.data?.last_name))}`,
            roleData: result?.data?.role,
            created_by: result?.data?.created_by
              ? {
                  ...result?.data?.created_by,
                  email: decryptByText(result?.data?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.last_name),
                  ),
                }
              : result?.data?.created_by,
            updated_by: result?.data?.updated_by
              ? {
                  ...result?.data?.updated_by,
                  email: decryptByText(result?.data?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.last_name),
                  ),
                }
              : result?.data?.updated_by,
          };
          dispatch({
            type: "UPDATE_TEAM_MEMBER_DATA",
            payload: newData,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateTeamMember", undefined);
          onClose();
        } else elseHandler(dispatch, "updateTeamMember", result);
        dispatchLoading(dispatch, "updateTeamMember", false);
      })
      .catch(catchHandler(dispatch, "updateTeamMember"));
  };

export const DeleteTeamMemberAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteTeamMember", true);
    axiosInstance
      .delete(`/users`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          onClose();
          dispatch({
            type: "DELETE_TEAM_MEMBER",
            payload: data?.id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteTeamMember", undefined);
        } else elseHandler(dispatch, "deleteTeamMember", result);
        dispatchLoading(dispatch, "deleteTeamMember", false);
      })
      .catch(catchHandler(dispatch, "deleteTeamMember"));
  };

export const GetPricesheetHistoryAPI =
  ({ page, limit, pricesheetId }: any, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPricesheetHistory", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;

    axiosInstance
      .get(`/price-sheets/history/${pricesheetId}`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        const newData =
          result?.data?.history?.length > 0
            ? result?.data?.history?.map((item: any) => {
                const firstName = CapitalizeFirstWord(
                  decryptByText(item?.user_id?.first_name),
                );
                const lastName = CapitalizeFirstWord(
                  decryptByText(item?.user_id?.last_name),
                );
                const name = `${firstName} ${lastName}`;
                return {
                  ...item,
                  user_id: {
                    ...item?.user_id,
                    first_name: firstName,
                    last_name: lastName,
                    name: name,
                  },
                };
              })
            : [];
        if (result?.success) {
          dispatch({
            type: "GET_PRICESHEET_HISTORY_DATA",
            payload: {
              page: page,
              data: newData,
              pricesheet: result?.data?.pricesheet,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.history?.length == limit);
          }
          dispatchError(dispatch, "getPricesheetHistory", undefined);
        } else {
          elseHandler(dispatch, "getPricesheetHistory", result);
        }
        dispatchLoading(dispatch, "getPricesheetHistory", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPricesheetHistory")(err);
      });
  };

export const GetEmployeeDetailsAPI =
  (id: string, cb?: (data: any) => void, year?: number) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getEmployeeDetails", true);
    axiosInstance
      .get(`/users/${id}/employee-details`, {
        params: year ? { year } : undefined,
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_EMPLOYEE_DETAILS",
            payload: result?.data,
          });
          if (cb) cb(result?.data);
        } else {
          elseHandler(dispatch, "getEmployeeDetails", result);
        }
        dispatchLoading(dispatch, "getEmployeeDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getEmployeeDetails")(err);
      });
  };

export const DeleteEmployeeScheduleAPI =
  (id: string, scheduleId: string, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteEmployeeSchedule", true);
    axiosInstance
      .delete(`/users/${id}/employee-details/schedule/${scheduleId}`, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_EMPLOYEE_DETAILS",
            payload: { schedule: result?.data }, // updating with remaining schedules returned by API
          });
          if (onSuccess) onSuccess();
          dispatchToast(dispatch, "success", result?.message);
        } else {
          elseHandler(dispatch, "deleteEmployeeSchedule", result);
        }
        dispatchLoading(dispatch, "deleteEmployeeSchedule", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteEmployeeSchedule")(err);
      });
  };

export const UpdateEmployeeDetailsAPI =
  (id: string, data: any, onSuccess?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateEmployeeDetails", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/users/${id}/employee-details`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_EMPLOYEE_DETAILS",
            payload: result?.data,
          });
          if (onSuccess) onSuccess();
          if (data?.biometric_authentication?.face) {
            dispatchToast(dispatch, "success", "Face registered successfully!");
          } else {
            dispatchToast(dispatch, "success", result?.message);
          }
        } else {
          elseHandler(dispatch, "updateEmployeeDetails", result);
        }
        dispatchLoading(dispatch, "updateEmployeeDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updateEmployeeDetails")(err);
      });
  };

export const GetEmploymentEndDateImpactAPI =
  (id: string, endDate: string, cb: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getEmploymentEndDateImpact", true);
    axiosInstance
      .get(`/users/${id}/employment-end-date-impact`, {
        params: { end_date: endDate },
        withCredentials: true,
      })
      .then((response) => {
        const result = responseDataFormate(response?.data);
        if (result?.success) {
          if (cb) cb(result?.data);
        } else {
          elseHandler(dispatch, "getEmploymentEndDateImpact", result);
        }
        dispatchLoading(dispatch, "getEmploymentEndDateImpact", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getEmploymentEndDateImpact")(err);
      });
  };

export const GetPtoHistoryAPI =
  (params: any, cb?: (data: any) => void) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPtoHistory", true);
    axiosInstance
      .get(`/pto-history`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (cb) cb(result?.data);
        } else {
          elseHandler(dispatch, "getPtoHistory", result);
        }
        dispatchLoading(dispatch, "getPtoHistory", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPtoHistory")(err);
      });
  };

export const GetEmployeeProfileHistoryAPI =
  (
    idOrOptions: string | { id?: string; filters?: any; onSuccess?: (data: any) => void; onError?: () => void },
    params?: any,
    cb?: (data: any) => void
  ) =>
  async (dispatch: (action: any) => void) => {
    let id: string;
    let requestParams: any;
    let onSuccessCb: ((data: any) => void) | undefined;
    let onErrorCb: (() => void) | undefined;

    if (typeof idOrOptions === "object") {
      id = idOrOptions.id || idOrOptions.filters?.source_id || idOrOptions.filters?.id;
      requestParams = idOrOptions.filters || {};
      onSuccessCb = idOrOptions.onSuccess;
      onErrorCb = idOrOptions.onError;
    } else {
      id = idOrOptions;
      requestParams = params;
      onSuccessCb = cb;
    }

    dispatchLoading(dispatch, "getEmployeeProfileHistory", true);
    axiosInstance
      .get(`/users/${id}/employee-profile-history`, {
        params: { ...requestParams },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccessCb) onSuccessCb(result?.data);
        } else {
          elseHandler(dispatch, "getEmployeeProfileHistory", result);
          if (onErrorCb) onErrorCb();
        }
        dispatchLoading(dispatch, "getEmployeeProfileHistory", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getEmployeeProfileHistory")(err);
        if (onErrorCb) onErrorCb();
      });
  };
